import { Platform } from 'react-native';

export const endpoint = 'https://us-central1-remote-work-br.cloudfunctions.net/getRemoteJobs';

// Google's official test ad units. Inlined (instead of imported from
// react-native-google-mobile-ads/TestIds) so this module stays safe to
// import from web-bundled code, where the ads package can't load.
// https://developers.google.com/admob/android/test-ads
const TEST_AD_UNITS = {
  banner: {
    android: 'ca-app-pub-3940256099942544/9214589741', // ADAPTIVE_BANNER
    ios: 'ca-app-pub-3940256099942544/2435281174',
  },
  native: {
    android: 'ca-app-pub-3940256099942544/2247696110', // NATIVE
    ios: 'ca-app-pub-3940256099942544/3986624511',
  },
  interstitial: {
    android: 'ca-app-pub-3940256099942544/1033173712', // INTERSTITIAL
    ios: 'ca-app-pub-3940256099942544/4411468910',
  },
};

// Production ad unit IDs for publisher pub-1622263906885975.
const PROD_AD_UNITS = {
  banner: {
    android: 'ca-app-pub-1622263906885975/7897117561',
    ios: 'ca-app-pub-1622263906885975/7111020639',
  },
  native: {
    android: 'ca-app-pub-1622263906885975/4728028748',
    ios: 'ca-app-pub-1622263906885975/8681526715',
  },
  interstitial: {
    android: 'ca-app-pub-1622263906885975/8594265333',
    ios: 'ca-app-pub-1622263906885975/2028856981',
  },
};

const pickPlatform = (units: { android: string; ios: string }) =>
  Platform.OS === 'ios' ? units.ios : units.android;

// In dev we always serve test units to avoid AdMob policy violations.
// In prod we serve real units, falling back to test if a slot is unset.
const resolve = (slot: 'banner' | 'native' | 'interstitial') => {
  const test = pickPlatform(TEST_AD_UNITS[slot]);
  if (__DEV__) return test;
  return pickPlatform(PROD_AD_UNITS[slot]) || test;
};

export const adUnits = {
  banner: resolve('banner'),
  native: resolve('native'),
  interstitial: resolve('interstitial'),
};

// RevenueCat public API keys. These are designed to be exposed in client
// code (RevenueCat enforces entitlements server-side). Get them from the
// RevenueCat dashboard → Project Settings → API keys.
//
// The iOS entry is still a `test_…` Web Billing / Stripe Test Mode key —
// real iOS purchases will fail until it is swapped for an `appl_…` key.
// `revenueCat.ts` logs a __DEV__ warning at boot when the prefix doesn't
// match the platform.
export const revenueCatApiKeys = {
  ios: 'appl_rtlThHJWsmUMfhYfxgXagBBhtCp',
  android: 'goog_EKKGESUCTiaweJOuzLokkgeNNMf',
};

export const REMOVE_ADS_ENTITLEMENT = 'remove_ads';

// Fallback product identifiers that should flip the remove-ads gate even
// when no `remove_ads` entitlement is attached to them in the RevenueCat
// dashboard. Useful for:
//   • Test-store apps (RC's sandbox app type) where entitlement attachment
//     UI may not be exposed.
//   • Belt-and-braces for non-consumable purchases — if the product was
//     bought on this device, ads should be off regardless of dashboard
//     mis-config.
// Production should still configure the `remove_ads` entitlement and attach
// these products to it; this list is the safety net, not the source of truth.
export const REMOVE_ADS_PRODUCTS = ['lifetime', 'remove_ads_lifetime', 'remove_ads'];

export default {};
